import React from 'react';
import { Link } from 'react-router-dom';

interface Props { className?: string; children?: React.ReactNode }

/** Link to the on-site booking page (/book), which embeds the online booking form. */
const BookLink: React.FC<Props> = ({ className = 'btn btn--primary', children = 'Book Now' }) => (
  <Link to="/book" className={className}>{children}</Link>
);

export default BookLink;
